// French for the Admin page: the rail, the posture claims, the consequence cards, the trail,
// the switches (incl. the accent control and its record note), the modals. Registered on load.
import { registerFr } from '../i18n/index.js';

registerFr({
  // ── the accent control ──
  'Pick the accent colour': 'Choisir la couleur d’accent',
  'Accent colour as hex': 'Couleur d’accent en hexadécimal',
  "Back to ATTEST's own accent": 'Revenir à l’accent propre d’ATTEST',
  "ATTEST's own": 'Propre à ATTEST',
  "ATTEST's own iron-gall blue": 'Le bleu ferro-gallique propre d’ATTEST',
  'is in force — 6.78:1 on the field, 7.58:1 on the sheet.': 'est en vigueur — 6.78:1 sur le champ, 7.58:1 sur la feuille.',
  'Not a colour yet — six hex digits after the #.': 'Pas encore une couleur — six chiffres hexadécimaux après le #.',
  'day · a link on the field': 'jour · un lien sur le champ',
  'day · a link on the sheet': 'jour · un lien sur la feuille',
  'day · text on a filled control': 'jour · texte sur un contrôle rempli',
  'night · a link on the field': 'nuit · un lien sur le champ',
  'night · a link on the sheet': 'nuit · un lien sur la feuille',
  'night · text on a filled control': 'nuit · texte sur un contrôle rempli',
  'night': 'nuit',
  'day': 'jour',
  'a link': 'un lien',
  'surface': 'surface',
  'ratio': 'contraste',
  'AA {aa}:1': 'AA {aa}:1',
  'passes': 'réussit',
  'FAILS': 'ÉCHOUE',
  'Passes AA on every surface — Save applies it at once, for everyone, on this and every next load.':
    'Réussit AA sur chaque surface — Enregistrer l’applique aussitôt, pour tout le monde, dès ce chargement et chaque suivant.',
  'Save will be refused: {problems}.': 'Enregistrer sera refusé : {problems}.',
  'The nearest shade of this hue that passes is': 'La nuance la plus proche de cette teinte qui réussit est',
  'use it': 'Utiliser',

  // ── loaders / rail ──
  'The vocabulary did not load': 'Le vocabulaire n’a pas été chargé',
  'The trail did not load': 'La piste d’audit n’a pas été chargée',
  'the posture did not load': 'l’état n’a pas été chargé',
  'unknown': 'inconnu',
  'auth_settings did not answer': 'auth_settings n’a pas répondu',
  '{n} email admitted': '{n} e-mail admis',
  '{n} emails admitted': '{n} e-mails admis',
  'anyone may register': 'tout le monde peut s’inscrire',
  'operator': 'opérateur',
  'operators': 'opérateurs',
  '{admins} admin · {plain} plain': '{admins} admin · {plain} sans',
  'none created yet': 'aucun créé pour l’instant',
  'live': 'actif',
  'the token tally did not run': 'le décompte des jetons n’a pas été exécuté',
  '{total} issued · {revoked} revoked': '{total} émis · {revoked} révoqués',
  'none issued': 'aucun émis',
  '{wired} of {total}': '{wired} sur {total}',
  'wired': 'câblé',
  '{n} read by nothing': '{n} lu par rien',
  'every key has a reader': 'chaque clé a un lecteur',
  'events': 'événements',
  '{n} on {date}': '{n} le {date}',
  'nothing in 30 days': 'rien en 30 jours',
  'REALM': 'DOMAINE',
  'ACCOUNTS': 'COMPTES',
  'AGENT KEYS': 'CLÉS AGENT',
  'SWITCHES': 'COMMUTATEURS',
  'TRAIL': 'PISTE',
  'Posture': 'État',
  'Switches': 'Commutateurs',
  'The trail': 'La piste d’audit',

  // ── posture claims ──
  'The registration mode could not be read — this claim did NOT pass, it did not run.':
    'Le mode d’inscription n’a pas pu être lu — cette affirmation n’a PAS réussi, elle n’a pas été vérifiée.',
  'Registration is closed. Only an admitted email can create an operator account.':
    'L’inscription est fermée. Seul un e-mail admis peut créer un compte opérateur.',
  'Registration is OPEN — anyone who can reach the host can create an operator account.':
    'L’inscription est OUVERTE — quiconque peut atteindre l’hôte peut créer un compte opérateur.',
  'reasserted on every boot by': 'réaffirmé à chaque démarrage par',
  'not reasserted on boot': 'non réaffirmé au démarrage',
  'Close it': 'Fermer',
  'No email is admitted — with the door shut, nothing can create an account.':
    'Aucun e-mail n’est admis — porte fermée, rien ne peut créer de compte.',
  'One email is admitted: {email}': 'Un e-mail est admis : {email}',
  '{n} emails are admitted.': '{n} e-mails sont admis.',
  'since': 'depuis',
  'empty': 'vide',
  'newest: {email}': 'le plus récent : {email}',
  'Withdraw the newest': 'Retirer le plus récent',
  'No account exists yet — the first admitted email creates one at first login.':
    'Aucun compte n’existe encore — le premier e-mail admis en crée un dès la première connexion.',
  '{n} account exists whose address is NOT on the allowlist — admitted, used, then withdrawn.':
    '{n} compte existe dont l’adresse n’est PAS sur la liste d’admission — admise, utilisée, puis retirée.',
  '{n} accounts exist whose address is NOT on the allowlist — admitted, used, then withdrawn.':
    '{n} comptes existent dont l’adresse n’est PAS sur la liste d’admission — admise, utilisée, puis retirée.',
  'One account exists, and it is that email: {name}': 'Un compte existe, et c’est cet e-mail : {name}',
  '{n} accounts exist. {admins} of them can write settings and read this trail.':
    '{n} comptes existent. {admins} d’entre eux peuvent modifier les paramètres et lire cette piste d’audit.',
  'admin': 'admin',
  'password set': 'mot de passe défini',
  'no password — SSO only': 'aucun mot de passe — SSO uniquement',
  'Change my password': 'Modifier mon mot de passe',
  'The agent-key tally did not run — whether anything outside this process can reach the tool surface is UNKNOWN.':
    'Le décompte des clés agent n’a pas été exécuté — si quelque chose en dehors de ce processus peut atteindre la surface d’outils est INCONNU.',
  'No agent key is live. Nothing outside this process can reach the engagement tool surface.':
    'Aucune clé agent n’est active. Rien en dehors de ce processus ne peut atteindre la surface d’outils du mandat.',
  '{n} agent key live and can call the tool surface.': '{n} clé agent est active et peut appeler la surface d’outils.',
  '{n} agent keys live and can call the tool surface.': '{n} clés agent sont actives et peuvent appeler la surface d’outils.',
  'issued': 'émise',
  'last expiry': 'dernière expiration',
  'Revoke all': 'Tout révoquer',
  'The client-account tally did not run.': 'Le décompte des comptes clients n’a pas été exécuté.',
  'No client account exists. The client realm shares nothing with this one — separate cookie, separate table, separate trail.':
    'Aucun compte client n’existe. Le domaine client ne partage rien avec celui-ci — cookie séparé, table séparée, piste d’audit séparée.',
  '{accounts} across {clients}.': '{accounts} répartis sur {clients}.',
  '{n} client account': '{n} compte client',
  '{n} client accounts': '{n} comptes clients',
  '{n} client': '{n} client',
  '{n} clients': '{n} clients',
  'administered on the Client Portal tab': 'géré depuis l’onglet Portail client',

  // ── filter chips ──
  'verb': 'verbe',
  'noun': 'nom',
  'class': 'classe',
  'engagement': 'mandat',
  'text': 'texte',
  'carries a written reason': 'porte une justification écrite',
  'destroyed a row': 'a détruit une ligne',
  'produced a hash': 'a produit un hachage',

  // ── acts / toasts ──
  'That is not an email address': 'Ce n’est pas une adresse e-mail',
  '{email} is admitted — and the act is in the trail below': '{email} est admis — et l’action figure dans la piste d’audit ci-dessous',
  'The email could not be admitted': 'L’e-mail n’a pas pu être admis',
  '{email} withdrawn': '{email} retiré',
  'The address could not be withdrawn': 'L’adresse n’a pas pu être retirée',
  'Registration is closed — only an admitted email can create an account':
    'L’inscription est fermée — seul un e-mail admis peut créer un compte',
  'The registration mode could not be changed': 'Le mode d’inscription n’a pas pu être modifié',
  '{n} agent key revoked': '{n} clé agent révoquée',
  '{n} agent keys revoked': '{n} clés agent révoquées',
  'The keys could not be revoked': 'Les clés n’ont pas pu être révoquées',
  'The new password must be at least 8 characters': 'Le nouveau mot de passe doit compter au moins 8 caractères',
  'The two new passwords do not match': 'Les deux nouveaux mots de passe ne correspondent pas',
  'Your password is changed': 'Votre mot de passe est modifié',
  'The password could not be changed': 'Le mot de passe n’a pas pu être modifié',
  '{n} switch saved': '{n} commutateur enregistré',
  '{n} switches saved': '{n} commutateurs enregistrés',
  'The switches could not be saved': 'Les commutateurs n’ont pas pu être enregistrés',
  'Citation copied': 'Citation copiée',

  // ── masthead ──
  'Admin': 'Admin',
  'sealed': 'scellé',
  'open': 'ouvert',
  "the system's own record — the one page whose subject is Signet":
    'l’enregistrement du système lui-même — la seule page dont le sujet est Signet',
  'read-only — you are not an admin': 'lecture seule — vous n’êtes pas admin',
  'The trail is downloading with the filters you have on': 'La piste d’audit se télécharge avec les filtres actifs',
  'Export the trail': 'Exporter la piste d’audit',

  // ── zone 1 · posture ──
  'reading': 'en lecture',
  '{n} claims · all hold': '{n} affirmations · toutes tiennent',
  '{bad} of {total} do not hold': '{bad} sur {total} ne tiennent pas',
  'Admit an email': 'Admettre un e-mail',
  'The posture did not load': 'L’état n’a pas été chargé',
  "Reading the system's own state…": 'Lecture de l’état propre du système…',
  'The {source} claim': 'L’affirmation {source}',

  // ── zone 2 · consequence ──
  'Consequence': 'Conséquence',
  '{decisions} of {total} entries are a decision · the rest are keystrokes':
    '{decisions} sur {total} entrées sont une décision · le reste, de simples frappes',
  'the tallies did not run': 'les décomptes n’ont pas été exécutés',
  'The client realm has no consequence classes': 'Le domaine client n’a pas de classes de conséquence',
  'records reading, not deciding: a client can view, comment and run a test case, and none of those destroys a row or produces a hash. Switch the trail back to the operator realm to see the three memberships.':
    'enregistre la lecture, non la décision : un client peut consulter, commenter et exécuter un cas de test, et rien de tout cela ne détruit une ligne ni ne produit un hachage. Repassez la piste d’audit sur le domaine opérateur pour voir les trois appartenances.',
  'The consequence tallies did not load': 'Les décomptes de conséquence n’ont pas été chargés',
  'The vocabulary payload carried no tallies.': 'La réponse du vocabulaire ne contenait aucun décompte.',
  'of {n}': 'sur {n}',
  'Carry a reason you typed': 'Portent une justification que vous avez tapée',
  'Every place you went round a guarantee and had to say why.':
    'Chaque endroit où vous avez contourné une garantie et avez dû dire pourquoi.',
  'more rows carry a note, but it is one of': 'lignes de plus portent une note, mais c’est l’une des',
  'constants the server writes — those are the system speaking, and they are not here.':
    'constantes que le serveur écrit — c’est le système qui parle, et elles ne sont pas ici.',
  'Show them in the trail →': 'Les montrer dans la piste d’audit →',
  'Destroyed a row': 'Ont détruit une ligne',
  'Including': 'Dont',
  'clients and': 'clients et',
  'engagements deleted with their cascades. The': 'mandats supprimés avec leurs cascades. Le champ',
  'blob in the entry is the only surviving copy of each —': 'dans l’entrée est l’unique copie conservée de chacun —',
  'characters of record that exists nowhere else in the database.':
    'caractères d’archive qui n’existent nulle part ailleurs dans la base de données.',
  'Produced a hash a signature stands on': 'Ont produit un hachage sur lequel repose une signature',
  'Signatures, baselines and issued versions.': 'Signatures, baselines et versions émises.',
  'The baseline is sacred': 'La baseline est intangible',
  '— these are the entries an argument about scope is settled on, and the content hash in each is rendered whole, never truncated.':
    '— ce sont les entrées sur lesquelles se tranche un désaccord sur le périmètre, et le hachage de contenu de chacune est rendu en entier, jamais tronqué.',
  'Membership is a query, not an opinion: a row is here when it carries a written reason, when it destroyed a row whose only surviving copy is the entry itself, or when it produced a hash that a signature depends on. Everything else is a keystroke and lives in the trail.':
    'L’appartenance est une requête, pas une opinion : une ligne est ici quand elle porte une justification écrite, quand elle a détruit une ligne dont l’entrée elle-même est l’unique copie conservée, ou quand elle a produit un hachage dont dépend une signature. Tout le reste est une frappe et vit dans la piste d’audit.',

  // ── zone 3 · the trail ──
  '{n} client-realm events': '{n} événements du domaine client',
  'carry an IP': 'portent une IP',
  '{n} operator-realm events · {verbs} verbs': '{n} événements du domaine opérateur · {verbs} verbes',
  'What happened': 'Ce qui s’est passé',
  '{verbs} verbs · {nouns} nouns': '{verbs} verbes · {nouns} noms',
  'The vocabulary did not load.': 'Le vocabulaire n’a pas été chargé.',
  'Try again': 'Réessayer',
  'Nothing has been recorded in this realm yet.': 'Rien n’a encore été enregistré dans ce domaine.',
  '{fam} — click to open, double-click to filter the trail to all {n} of them':
    '{fam} — cliquez pour ouvrir, double-cliquez pour filtrer la piste d’audit sur les {n}',
  '{action} · last {date}': '{action} · dernier {date}',
  'Operator': 'Opérateur',
  'Client': 'Client',
  'actor, IP and user-agent on every row': 'acteur, IP et user-agent sur chaque ligne',
  'the manual logger takes no IP, so the column is empty by construction':
    'l’enregistreur manuel ne prend pas d’IP, la colonne est donc vide par construction',
  '{n} event on {date}': '{n} événement le {date}',
  '{n} events on {date}': '{n} événements le {date}',
  'Newest first': 'Les plus récents d’abord',
  '{n} entries': '{n} entrées',
  'of': 'sur',
  'clear‖input': 'effacer',
  'Clear all': 'Tout effacer',
  'Search the details…': 'Rechercher dans les détails…',
  'Search the trail': 'Rechercher dans la piste d’audit',
  'Reading the record…': 'Lecture de l’enregistrement…',
  'Nothing matches': 'Rien ne correspond',
  'This combination exists in the vocabulary but not in the record. The catalogue on the left carries a count for every verb, so the nearest thing with rows is the one with the largest number.':
    'Cette combinaison existe dans le vocabulaire mais pas dans l’enregistrement. Le catalogue à gauche porte un nombre pour chaque verbe ; le plus proche avec des lignes est donc celui qui a le plus grand nombre.',
  'Clear the filters': 'Réinitialiser les filtres',
  'Nothing has been recorded in this realm': 'Rien n’a été enregistré dans ce domaine',
  'Every mutation in Signet writes one row here. An empty trail means nothing has been written yet — not that the recorder is off.':
    'Chaque modification dans Signet écrit une ligne ici. Une piste d’audit vide signifie que rien n’a encore été écrit — pas que l’enregistreur est désactivé.',
  'client realm': 'domaine client',
  'system · agent': 'système · agent',
  'reason': 'justification',
  'only copy': 'copie unique',
  'hash': 'hachage',
  'The reason, as written': 'La justification, telle qu’écrite',
  'Note — a constant the server writes ({n} row carries this exact string)':
    'Note — une constante que le serveur écrit ({n} ligne porte exactement ce texte)',
  'Note — a constant the server writes ({n} rows carry this exact string)':
    'Note — une constante que le serveur écrit ({n} lignes portent exactement ce texte)',
  'field': 'champ',
  'before': 'avant',
  'after': 'après',
  'This entry records the act and nothing else — no before/after was captured.':
    'Cette entrée enregistre l’action et rien d’autre — aucun avant/après n’a été capturé.',
  'Copy the citation': 'Copier la citation',
  'Open {what} →': 'Ouvrir {what} →',
  'This entry carries no route.': 'Cette entrée ne porte aucune route.',
  '← Newer': '← Plus récent',
  'Older →': 'Plus ancien →',

  // ── zone 4 · switches ──
  '{wired} of {total} are read by anything': '{wired} sur {total} sont lus par quelque chose',
  'Revert': 'Abandonner',
  'Saving…': 'Enregistrement…',
  'Save': 'Enregistrer',
  'nothing edited': 'aucune modification',
  'The switches did not load': 'Les commutateurs n’ont pas été chargés',
  'Reading…': 'Chargement…',
  'This build exposes no settings': 'Ce build n’expose aucun paramètre',
  'The whitelist in routes/admin.ts is empty.': 'La liste blanche dans routes/admin.ts est vide.',
  'fixed‖model': 'Forfait',
  'tm‖model': 'En régie',
  'capped_tm‖model': 'Régie plafonnée',
  'retainer‖model': 'Retainer',
  'Nothing reads this.': 'Rien ne lit ceci.',
  'Read by': 'Lu par',
  'no consumer': 'aucun lecteur',
  "How the accent holds ATTEST's contrast law": 'Comment l’accent respecte la loi de contraste d’ATTEST',
  'the first control was removed; this one is gated': 'le premier contrôle a été supprimé ; celui-ci est verrouillé',
  'The first': 'Le premier',
  'derived its ramp on': 'calculait sa rampe lors du',
  'mount': 'mount',
  'and wrote it inline on': 'et l’écrivait en style inline sur',
  '— so the tint applied only after someone opened Admin, drifted per session, never carried':
    '— si bien que la teinte ne s’appliquait qu’après l’ouverture d’Admin, dérivait d’une session à l’autre, ne portait jamais',
  ', and three of its five swatches failed AA with nothing on the write path but':
    ', et trois de ses cinq nuances échouaient au AA, rien d’autre sur le chemin d’écriture que',
  'Now: one exact colour.': 'Désormais : une seule couleur exacte.',
  'derives the whole ramp —': 'dérive toute la rampe —',
  ', for day and for night (the same hue lifted to ≥ 8:1 on the night field) — and measures the six ratios you see above. The server runs the same code on the write path and refuses anything under {aa}:1 on the field, the sheet or a filled control. What passes is served as':
    ', pour le jour et pour la nuit (la même teinte relevée à ≥ 8:1 sur le champ nocturne) — et mesure les six contrastes que vous voyez ci-dessus. Le serveur exécute le même code sur le chemin d’écriture et refuse tout ce qui est sous {aa}:1 sur le champ, la feuille ou un contrôle rempli. Ce qui réussit est servi sous forme de',
  ', linked after': ', lié après',
  'in both shells and read at boot before first paint: no inline styles, one tint everywhere, from the login page on.':
    'dans les deux shells et lu au démarrage avant le premier rendu : aucun style inline, une seule teinte partout, dès la page de connexion.',

  // ── modals ──
  'An admitted address may create ONE operator account at its first login. Nothing else changes: the address gets no admin rights, and withdrawing it later does not delete the account it created.':
    'Une adresse admise peut créer UN compte opérateur dès sa première connexion. Rien d’autre ne change : l’adresse n’obtient aucun droit admin, et la retirer par la suite ne supprime pas le compte qu’elle a créé.',
  'Cancel': 'Annuler',
  'Admit it': 'Admettre',
  'Current password': 'Mot de passe actuel',
  'New password': 'Nouveau mot de passe',
  'At least 8 characters.': 'Au moins 8 caractères.',
  'New password again': 'Nouveau mot de passe (à nouveau)',
  'Change it': 'Modifier',
  'Revoke every live agent key': 'Révoquer chaque clé agent active',
  'Revoke them': 'Révoquer',
  'Every unrevoked': 'Chaque ligne encore valide de',
  'row is marked revoked. A run in flight loses the tool surface at its next call and will fail; nothing already written is undone. New keys are minted per run, so the next dispatch works normally.':
    'est marquée comme révoquée. Une exécution en cours perd la surface d’outils à son prochain appel et échoue ; rien de déjà écrit n’est annulé. De nouvelles clés sont émises à chaque exécution, le prochain dispatch fonctionne donc normalement.',
  'Close registration': 'Fermer l’inscription',
  'becomes': 'devient',
  '. Accounts that already exist keep working; only the creation of NEW accounts is restricted to admitted addresses.':
    '. Les comptes déjà existants continuent de fonctionner ; seule la création de NOUVEAUX comptes est restreinte aux adresses admises.',
  'Withdraw an admitted email': 'Retirer un e-mail admis',
  'Withdraw it': 'Retirer',
  'can no longer create an operator account. If it already created one, that account keeps working — this is the door, not the room.':
    'ne peut plus créer de compte opérateur. Si elle en a déjà créé un, ce compte continue de fonctionner — ceci est la porte, pas la pièce.',
}, 'AdminPage');
